/**
 * What 3 Ingredients - Print Handler
 * Triggers clean 1-page recipe printing
 */

export function triggerPrint() {
  window.print();
}
